/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * apiPaymentUrl
 * */

export default (client, { apiPaymentUrl }) => {
  const root = `${apiPaymentUrl}/deposit`

  return {
    getPaymentsDeposit() {
      const url = `${root}/types`
      return client.get(url)
    },

    methodDepositExt(data) {
      const url = root
      return client.post(url, data)
    },

    depositCardStatus(uuid) {
      const url = `${root}/status`
      const params = { uuid }
      return client.get(url, { params })
    },
    /**
     * @param {Object} GetCardIframeDTO
     * @param {'light' | 'dark'} GetCardIframeDTO.theme */
    getCardIframeUrl({ theme } = {}) {
      const params = {
        ...(theme && { theme }),
      }
      return client.get(`${root}/card_form/url`, { params })
    },
  }
}
